export default __webpack_public_path__ + "static/media/ANN-Balance.42159705.svg";